import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import { FadeTransitionModel } from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/fade-transition-model';
import {
    MorphTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/morph-transition-model';
import { PushTransitionModel } from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/push-transition-model';
import {
    SwitchTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/switch-transition-model';
import { CutTransitionModel } from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/cut-transition-model';
import { PullTransitionModel } from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/pull-transition-model';
import {
    CoverTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/cover-transition-model';
import {
    WarpTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/warp-transition-model';
import {
    NewsflashTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/newsflash-transition-model';
import {
    FlipTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/flip-transition-model';
import {
    GalleryTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/gallery-transition-model';
import {
    PrismTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/prism-transition-model';
import {
    FlashTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/flash-transition-model';
import {
    ICoverTransition, ICutTransition, IFadeTransition, IFlashTransition,
    IFlipTransition, IGalleryTransition, IMorphTransition, INewsflashTransition,
    IPrismTransition, IPullTransition, IPushTransition, ISwitchTransition, ITransitionModel, IWarpTransition,
} from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import {
    EmptyTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/empty-transition-model';

export type Transition =
    IFadeTransition |
    IMorphTransition |
    IPushTransition |
    ISwitchTransition|
    ICutTransition |
    IPullTransition |
    ICoverTransition |
    IWarpTransition |
    INewsflashTransition |
    IFlipTransition |
    IGalleryTransition |
    IPrismTransition |
    IFlashTransition;

// eslint-disable-next-line complexity
export function getTransitionModelByType(type?: TransitionType): ITransitionModel {
    switch (type) {
        case TransitionType.FADE:
            return new FadeTransitionModel();
        // morph之前显示降级为fade，但是支持编辑之后存在交互问题。移除降级当不支持处理
        // case TransitionType.MORPH:
        //     return new MorphTransitionModel();
        case TransitionType.PUSH:
            return new PushTransitionModel();
        case TransitionType.SWITCH:
            return new SwitchTransitionModel();
        case TransitionType.CUT:
            return new CutTransitionModel();
        case TransitionType.PULL:
            return new PullTransitionModel();
        case TransitionType.COVER:
            return new CoverTransitionModel();
        case TransitionType.WARP:
            return new WarpTransitionModel();
        case TransitionType.NEWSFLASH:
            return new NewsflashTransitionModel();
        case TransitionType.FLIP:
            return new FlipTransitionModel();
        case TransitionType.GALLERY:
            return new GalleryTransitionModel();
        case TransitionType.PRISM:
            return new PrismTransitionModel();
        case TransitionType.FLASH:
            return new FlashTransitionModel();
        default:
            return new EmptyTransitionModel();
    }
}
